import React, { useState, useEffect } from 'react';
import { InfoCard } from './InfoCardAccount';
import { FaWallet } from 'react-icons/fa';
import { CommonButton } from '../ui/CommonButton';
import ReferralCodeModal from '../../Pages/ReferralModal';
import { Text, Flex, Box, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useAppTheme } from '../../Hooks/useAppTheme';

export const AccountSectionTopInfoCard = ({
  userData,
  onCardAction,
  withdrawalAmount = 0,
  activeTab,
}) => {
  const theme = useAppTheme();
  const [showReferralModal, setShowReferralModal] = useState(false);

  // Parse balances safely
  const actualBalance = parseFloat(userData?.balance) || 0;
 
 const displayBalance = actualBalance < 0 ? 0 : actualBalance - (withdrawalAmount || 0);
 
  const mt5BalanceRaw = parseFloat(userData?.mt5balance) || 0;

  const isIB = userData?.role === 6;
  const isUser = userData?.role === 7;

  // Calculate balances per role
  const walletBalance = displayBalance;
  const mt5Balance = isUser ? displayBalance : mt5BalanceRaw;
  const totalBalance = isIB ? walletBalance + mt5BalanceRaw : walletBalance;

  const handleOpenReferralModal = () => setShowReferralModal(true);
  const handleCloseReferralModal = () => setShowReferralModal(false);

  useEffect(() => {}, [activeTab]);

  const accountData = [
    {
      title: 'Total Balance',
      value: `$${totalBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      hoverDetails: (
        <>
          <Flex justify="space-between" align="center" mb={1}>
            <Text fontSize="xs" style={{ color: theme.textSecondary }}>Wallet Balance</Text>
            <Text fontSize="sm" style={{ color: theme.textSecondary }} fontWeight="semibold">${walletBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text>
          </Flex>
          <Flex justify="space-between" align="center" mb={1}>
            <Text fontSize="xs" style={{ color: theme.textSecondary }}>MT5 Balance</Text>
            <Text fontSize="sm" style={{ color: theme.textSecondary }} fontWeight="semibold">${mt5Balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text>
          </Flex>
          <Box borderTop="1px solid" borderColor={theme.borderPrimary} my={2} />
          <Flex justify="space-between" align="center">
            <Text fontWeight="semibold" style={{ color: theme.textPrimary }}>Total</Text>
            <Text fontWeight="semibold" style={{ color: theme.textPrimary }}>${totalBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text>
          </Flex>
        </>
      ),
    },
    {
      title: 'Wallet Balance',
      value: `$${walletBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      hoverDetails: (
        <Text fontSize="sm" style={{ color: theme.textSecondary }}>Available in wallet for trading/withdrawal.</Text>
      ),
    },
    {
      title: 'MT5 Balance',
      value: `$${mt5Balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      hoverDetails: (
        <Text fontSize="sm" style={{ color: theme.textSecondary }}>Funds currently held in MT5 trading platform.</Text>
      ),
    },
    {
      title: 'Wallet ID',
      inline: true,
      value: { id: userData?.walletId || '#12345' },
    },
  ];

  const buttons = (
    <Flex 
      wrap="wrap" 
      justify="center" 
      mt={4} 
      gap={3}
      width="100%"
    >
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <CommonButton 
          onClick={handleOpenReferralModal} 
          text="Referral Program" 
          size="md"
          variant="gradient"
        />
      </motion.div>
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <CommonButton
          onClick={() => onCardAction('wallet-deposit-widthdraw')}
          size="md"
          text="Deposit / Withdraw"
          variant="gradient"
        />
      </motion.div>
      {/* <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <CommonButton 
          // onClick={handleOpenReferralModal} 
          text="Free Trial" 
          size="md"
          variant="gradient"
        />
      </motion.div> */}
      {/* <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <CommonButton
          // onClick={() => onCardAction('wallet-deposit-widthdraw')}
          size="md"
          text="Start Challenge"
          variant="gradient"
        />
      </motion.div> */}
    </Flex>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <InfoCard 
        icon={
          <Icon 
            as={FaWallet} 
            boxSize={6} 
            color="white"
          />
        } 
        data={accountData} 
        buttons={buttons} 
      />

      {showReferralModal && (
        <ReferralCodeModal
          closeModal={handleCloseReferralModal}
          userId={userData?._id}
          referralCode={userData?.referralCode}
        />
      )}
    </motion.div>
  );
};